import * as React from 'react';

import cx from 'classnames';

type Appearance = 'neutral' | 'orange';

interface Props {
  children: React.ReactNode;
  appearance?: Appearance;
}
type Classes = {
  backgroundColor: string;
  textColor: string;
};

const styleMap: Record<Appearance, Classes> = {
  neutral: {
    backgroundColor: 'bg-grey-50',
    textColor: 'text-grey-900',
  },
  orange: {
    backgroundColor: 'bg-orange-50',
    textColor: 'text-orange-900',
  },
};

export function InlineMessage({ appearance = 'neutral', children }: Props) {
  const { backgroundColor, textColor } = styleMap[appearance];

  return (
    <div
      className={cx(
        'py-2 pl-4 pr-2 rounded-4 text-sans text-xs font-400 leading-normal',
        backgroundColor,
        textColor
      )}
    >
      {children}
    </div>
  );
}
